module.exports = __webpack_public_path__ + "img/hall_3.7224b356.jpg";